export default __webpack_public_path__ + "de927674ffff453dfb12f4a3c53ed433.png";